export default {
      id: "list-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#list",
      toString: function () {
        return this.url;
      }
    }